/* eslint-disable @typescript-eslint/no-empty-function */
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import {
  getAccountSchema,
  waitForGigya,
} from 'src/services/gigya/gigya-service';
import { SubscriptionsSchema } from '../types';

interface ISchemaContext {
  subscriptionsSchema: SubscriptionsSchema | null;
}

const SchemaContext = createContext<ISchemaContext>({
  subscriptionsSchema: null,
});

const useSchema = (): ISchemaContext => useContext(SchemaContext);

export const SchemaProvider: React.FC = ({ children }) => {
  const [subscriptionsSchema, setSubscriptionsSchema] = useState<null>(null);

  useEffect(() => {
    waitForGigya()
      .then(() => {
        getAccountSchema(handleSchemaUpdate);
      })
      .catch((err) => console.log('GIGYA ERROR; ', err));
  }, []);

  const handleSchemaUpdate = useCallback(
    (update) => {
      setSubscriptionsSchema(update.subscriptionsSchema);
    },
    [setSubscriptionsSchema]
  );

  return (
    <SchemaContext.Provider
      value={useMemo(
        () => ({
          subscriptionsSchema,
        }),
        [subscriptionsSchema]
      )}
    >
      {children}
    </SchemaContext.Provider>
  );
};

export default useSchema;
